import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  submit(e) {
    if (e.which === 13 && !e.shiftKey) {
      this.formTarget.submit()
      e.preventDefault()
    }
  }

  edit() {
    this.formTarget.classList.toggle("hidden")
  }
}
